module.exports = __webpack_public_path__ + "static/media/0321_IMG_LES_MURS_P21_UNI_PERGAMON_HORIZONTAL.275feea5.png";